import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Change, changeResult } from './change';
import { ChangeService } from './change.service';
import { SearchCriteria } from './searchCriteria';



@Injectable({ providedIn: 'root' })
export class HomeResolver  {

    private _ChangeService = inject(ChangeService);

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): changeResult | Observable<changeResult> | Promise<changeResult> {


       // this._ChangeService.test().subscribe( f => console.log(f));


      //  const c: Change[] = [];
     //   return c;

      const search: SearchCriteria = new SearchCriteria();
      search.changeMadeOperator = SearchCriteria.changeMadeAll;
      search.count = 25;

      return this._ChangeService.searchRecordWithCount(search);
    }

}
